/**
 *
 * Directionable Cards
 *
 * Simple UI for creating the hovers an overlay in the same direction as the mouse activity
 *
 * Based on "Directional Aware Hover Goodness" https://codepen.io/gortiz022/pen/ZEzLqjB
 *
 * //Direction aware image gallery effect
 //created by http://8bit-code.com
 //tutorial at http://www.8bit-code.com/tutorials/direction-aware-image-gallery-effect
 *
 */

const $     = require('jquery');
const _model  = require( './_model' );

var Directionable = function (el) {

  this.element       = el;
  this.$el         = $(el);
  this.$mainCard       = this.$el.find('.directionable-card__main');
  this.$overlay       = this.$el.find('.directionable-card__overlay');
  this.$presetDirection   =  (this.$el.data().hasOwnProperty('direction') ) ? this.$el.attr('data-direction') : false;

  this.directionPresets = {
    top: 0,
    right: 1,
    bottom: 2,
    left: 3

  };

  this.init();
};

Directionable.prototype.init = function () {

  //if there is no overlay, then let's cancel this plugin
  if( !this.$overlay.length ){
    return;
  }

  this.$el
    .on('mouseenter', this.event__overlayIn.bind(this))
    .on('mouseleave', this.event__overlayOut.bind(this));

};

Directionable.prototype.get_direction = function (e) {
  var target = e.currentTarget;
  var $target = $(target);

  /** the width and height of the current div **/
  var w = target.offsetWidth;
  var h = target.offsetHeight;

  /** calculate the x and y to get an angle to the center of the div from that x and y. **/
  /** gets the x value relative to the center of the DIV and "normalize" it **/
  var x = (e.originalEvent.pageX - e.currentTarget.offsetLeft - (w / 2)) * (w > h ? (h / w) : 1);
  var y = (e.originalEvent.pageY - e.currentTarget.offsetTop - (h / 2)) * (h > w ? (w / h) : 1);

  //console.table(e.originalEvent.pageX, e.currentTarget.offsetLeft, e.originalEvent.pageY, e.currentTarget.offsetTop);


  /** the angle and the direction from where the mouse came in/went out clockwise (TRBL=0123);**/
  /** first calculate the angle of the point,
   add 180 deg to get rid of the negative values
   divide by 90 to get the quadrant
   add 3 and do a modulo by 4  to shift the quadrants to a proper clockwise TRBL (top/right/bottom/left) **/
  var math = Math.round((((Math.atan2(y, x) * (180 / Math.PI)) + 180) / 90) + 3) % 4;

  return math;


};

Directionable.prototype.event__overlayIn = function (e) {

  var edge;
  if (this.$presetDirection) {

    edge = this.directionPresets[this.$presetDirection];

  } else {
    edge = this.get_direction(e);
  }


  var In = new TimelineMax();

  switch (edge) {
    case 0:
      //direction top
      //tween this.$overlay from the right
      In
        .set(this.$overlay, {y: '-105%', x: '0%'})
        .to(this.$overlay, .5, {y: '0%'});
      break;

    case 1:
      //direction right
      //tween this.$overlay from the right
      In
        .set(this.$overlay, {y: '0%', x: '105%'})
        .to(this.$overlay, .5, {x: '0%'});
      break;


    case 2:
      //direction bottom
      //tween this.$overlay from the right
      In
        .set(this.$overlay, {y: '105%', x: '0%'})
        .to(this.$overlay, .5, {y: '0%'});
      break;

    case 3:
      //direction left
      //tween overlay from the left
      In
        .set(this.$overlay, {y: '0%', x: '-105%'})
        .to(this.$overlay, .5, {x: '0%'});
      break;


  }
};

Directionable.prototype.event__overlayOut = function (e) {

  var edge;
  if (this.$presetDirection) {

    edge = this.directionPresets[this.$presetDirection];

  } else {
    edge = this.get_direction(e);
  }


  var In = new TimelineMax();

  switch (edge) {

    case 0:
      //direction top
      In
        .to(this.$overlay, .5, {y: '-105%'});
      break;

    case 1:
      //direction right
      In
        .to(this.$overlay, .5, {x: '105%'});
      break;

    case 2:
      //direction bottom
      In
        .to(this.$overlay, .5, {y: '105%'});
      break;

    case 3:
      //direction left
      In
        .to(this.$overlay, .5, {x: '-105%'});
      break;

  }

};


$(document).ready(function () {
  $('.directionable-card').each(function () {

    try{
      new Directionable(this);
    }catch (e) {
      console.log( this, e );
    }

  });

});

module.exports = Directionable;
